<template lang="pug">
  v-row
    v-col(cols="12")
      v-list-item(class="pl-0")
        v-list-item-content
          v-list-item-title
            h1(class="mb-2") {{ $route.meta.title }}
        //- v-list-item-action
        //-   v-btn(
        //-     :to="{ name: 'TaskCreate', query: { type: 'template' } }"
        //-     color="success"
        //-     class="px-3"
        //-     rounded
        //-   )
        //-     v-icon mdi-plus
        //-     span.ml-2.d-none.d-sm-block Добавить шаблон
    v-col(cols="12")
      v-card(class="sdo-card")
        // Поле с поиском по названию
        v-card-text
          v-text-field(
            v-model="searchInput"
            @input="searchTasks($event)"
            label="Поиск"
            :loading="loadingSearch"
            append-icon="mdi-magnify"
            hide-details rounded filled clearable
          )

        // Список тегов
        v-card-text
          v-fade-transition(leave-absolute)
            v-skeleton-loader(v-if="loadingTags" :types="{ 'tags': 'chip@7' }" type="tags")
            v-chip-group(
              v-if="!loadingTags"
              v-model="selectedTags"
              active-class="success--text"
              multiple
            )
              v-chip.mr-2(
                v-for="tag in tags" :key="tag.id"
                :value="tag.id"
                filter outlined
              ) {{ tag.name }}

    // Список папок
    task-list-folders(
      v-if="taskListInizialized"
      :remove-task="taskListInizialized.removeTask"
      @folder-select="folder = $event"
    )
    // Список заданий
    task-list-items(
      @inizialized="taskListInizialized = $event"
      :search="search"
      :folder="folder"
      :selected-tags="selectedTags"
    )

</template>

<script>
import { mapGetters } from 'vuex';
import _debounce from 'lodash/debounce';
import TagSelect from '@/components/InputFields/TagSelect.vue';
import TaskListFolders from '@/modules/Tasks/pages/TaskList/TaskListFolders.vue';
import TaskListItems from '@/modules/Tasks/pages/TaskList/TaskListItems.vue';

export default {
  name: 'TaskList',
  components: { TaskListItems, TaskListFolders, TagSelect },
  data: () => ({
    searchInput: '',
    search: '',
    folder: null,
    loadingTags: true,
    loadings: {},
    tags: [],
    selectedTags: [],
    loadingSearch: false,
    taskListInizialized: null,
  }),
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
  },
  mounted() {
    this.getTagList();
  },
  methods: {
    searchTasks: _debounce(function (search) {
      this.search = search;
    }, 500),
    getTagList() {
      this.loadingTags = true;
      this.$rHandler(
        this.$api.tag.index(),
        (r) => {
          this.tags = r.data.data;
          this.loadingTags = false;
        },
        () => {
          this.loadingTags = false;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .v-skeleton-loader__tags {
    display: flex;
    padding-top: 10px;
    padding-bottom: 6px;
    padding-left: 50px;
    .v-skeleton-loader__chip {
      margin-right: 8px;
    }
  }

</style>
